import React, { useEffect, useRef, useState } from "react";

// Parses "150+", "100%", "10+ YRS" -> { num, prefix, suffix }
function parse(value) {
  const match = String(value).match(/(\d[\d,]*)/);
  if (!match) return { num: null, prefix: "", suffix: String(value) };
  const raw = match[1];
  const num = parseInt(raw.replace(/,/g, ""), 10);
  const idx = match.index;
  return {
    num,
    prefix: String(value).slice(0, idx),
    suffix: String(value).slice(idx + raw.length),
  };
}

const easeOut = (t) => 1 - Math.pow(1 - t, 3);

export default function CountUp({ value, duration = 1600, className = "", "data-testid": testId }) {
  const { num, prefix, suffix } = parse(value);
  const [display, setDisplay] = useState(num === null ? value : `${prefix}0${suffix}`);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    if (num === null) return;
    const el = ref.current;
    if (!el) return;

    const run = () => {
      if (started.current) return;
      started.current = true;
      const start = performance.now();
      const tick = (now) => {
        const t = Math.min((now - start) / duration, 1);
        const current = Math.round(easeOut(t) * num);
        setDisplay(`${prefix}${current}${suffix}`);
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && run()),
      { threshold: 0.4 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [num, prefix, suffix, duration]);

  return (
    <span ref={ref} className={className} data-testid={testId}>
      {display}
    </span>
  );
}
